module.exports = __webpack_public_path__ + "img/join-4.41e047a9.png";